import { clientEnv } from '@/config/env/client';
import { type ServicePathType } from '@/utils/cms/api';

export const ROUTES = {
  HOME: {
    pathname: '/',
  },
  BOOKING: {
    pathname: '/cerca',
  },
  CHECKOUT_RESERVATION: {
    pathname: '/checkout/prenota',
  },
  CHECKOUT_RECAP: {
    pathname: '/checkout/riepilogo',
  },
  RESERVATION_MANAGE: {
    pathname: '/prenotazioni/gestisci',
  },
  RESERVATION_DELETE: {
    pathname: '/prenotazioni/cancella',
  },
  RESERVATION_EDIT: {
    pathname: '/prenotazioni/modifica',
  },
  CLINIC: {
    pathname: '/centri-medici',
  },
  SPECIALIST: {
    pathname: '/specialista',
  },
  TREATMENT: {
    pathname: '/prenota-visita',
  },
  PRIVACY_POLICY: {
    pathname: '/privacy-policy',
  },
  PRIVACY_INFO: {
    pathname: '/informative/dav_infc_pren_01',
  },
  TERMS_AND_CONDITIONS: {
    pathname: '/termini-e-condizioni-del-servizio',
  },
  NOT_FOUND: {
    pathname: '/404',
  },
  STRUCTURES: {
    pathname: '/centri-medici',
  },
} as const;

type ServiceLocation =
  | { location: string; service: string } //
  | { location?: undefined; service?: string };

type Config = ServiceLocation & { absolute?: boolean };

export const generateServiceLocationUrl = (type: ServicePathType, { service, location, absolute = false }: Config): string => {
  const typePath = type === 'specialist' ? ROUTES.SPECIALIST.pathname : ROUTES.TREATMENT.pathname;

  const basePath = `${absolute ? clientEnv.NEXT_PUBLIC_SITE_URL : ''}${typePath}`;

  if (service && location) {
    return `${basePath}/${service}/${location}`;
  }

  if (service) {
    return `${basePath}/${service}`;
  }

  return basePath;
};
